import * as React from "react";
import {
  Block,
  Page,
  Navbar,
  NavTitle,
  Link,
  BlockTitle,
  NavRight,
  Button,
} from "framework7-react";
import { api, removeToken } from "src/utils/utils";
import { API_URL, CLOUD_FUNCTION } from "src/utils/constants";
import { EventEmmiter } from "src/utils/events.js";
import MenuTiendas from "../prefabs/MenuTiendas";
import CardOrder from "../prefabs/CardOrder";
import $ from "jquery";

export default class HomePage extends React.Component {
  public state = {
    stores: [] as any[],
    orders: [] as any[],
    ordersToRender: [] as any,
    inFilter: false,
  };
  public currentUserId: number | string = "todo";

  constructor(props: {} | Readonly<{}>) {
    super(props);
    this.logout = this.logout.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  public async refresh(showLoading?: boolean) {
    if (showLoading) {
      this.$f7?.dialog.preloader("Actualizando datos de MercadoLibre");
    }

    const data = (await api.get(
      API_URL + CLOUD_FUNCTION + "getDataMercadoAlerta",
      {}
    )) as {
      stores: any[];
      orders: any[];
    };
    // data.stores.forEach((store) => {
    //   const targetUserId = store.user_id; // user_id de la tienda que se desea obtener las órdenes
    //   const ordersOfTargetUser = data.orders.filter(
    //     (order) => order.user_id === targetUserId
    //   ); // Filtrar órdenes que corresponden a la tienda deseada
    //   store.orders = ordersOfTargetUser; // Asignar las órdenes al arreglo 'orders' de la tienda actual
    // });
    this.setState({
      stores: data.stores,
      orders: data.orders,
    });

    // * Actualizar automaticamente al NO estar buscando
    if (!this.state.inFilter) {
      this.orderByUserId(this.currentUserId);
    }

    EventEmmiter.dispatch("stores-updated", data);

    this.$f7?.dialog.close();
    this.$f7?.toast
      .create({
        text: "Ordenes actualizadas con éxito 🔄",
        position: "bottom",
        closeTimeout: 4500,
      })
      .open();

    setTimeout(() => {
      this.refresh(false);
    }, 10000);
  }

  public logout() {
    const dialog = this.$f7?.dialog.preloader("Cerrando sesión");
    dialog?.open();

    setTimeout(() => {
      removeToken();
      dialog?.close();

      const form = document.querySelector("#login-form") as HTMLFormElement;
      form.reset();

      const loginPageDialog = document.querySelector(
        "#login-screen"
      ) as HTMLElement;

      this.$f7?.loginScreen.open(loginPageDialog);
    }, 600);
  }

  public componentDidMount() {
    this.refresh();

    EventEmmiter.subscribe("change-store", (userId: string | string) => {
      this.orderByUserId(userId);
    });

    EventEmmiter.subscribe("results", (orders: any) => {
      this.setState({
        ordersToRender: orders,
        inFilter: true,
      });
    });
  }

  public orderByUserId(userId: number | string) {
    this.currentUserId = userId;

    if (userId === "todo") {
      return this.setState({
        ordersToRender: this.state.orders,
        inFilter: false,
      });
    }

    const ordersOfTargetUser = this.state.orders.filter(
      (order) => order.user_id === userId
    );
    this.setState({
      ordersToRender: ordersOfTargetUser,
      inFilter: false,
    });
  }

  public clearSearcher() {
    $(
      "#idOrder input, #remission input, #invoice input, #is_invoice select, #estatus select, #data_status select"
    ).val("");
    this.setState({
      inFilter: false,
    });
    this.refresh(true);
  }

  public async readQuestions(id: number, position: number) {
    this.$f7?.dialog.preloader("Abriendo Preguntas");
    console.log("id", id);

    await api.get<any>(
      "http://localhost:5000/openChromeProfilePreguntas/" + position,
      {}
    );

    const data = await api.get<any>(
      API_URL + CLOUD_FUNCTION + "readQuestion&id=" + id,
      {}
    );
    console.log(data);

    if (data.status === 200) {
      this.refresh();
    }
  }
  public async readMessages(id: number, position: number) {
    this.$f7?.dialog.preloader("Abriendo mensajes");
    console.log("id", id);

    await api.get<any>(
      "http://localhost:5000/openChromeProfile/" + position,
      {}
    );

    const data = await api.get<any>(
      API_URL + CLOUD_FUNCTION + "readMessages&id=" + id,
      {}
    );
    console.log(data);

    if (data.status === 200) {
      this.refresh();
    }
  }

  public render() {
    return (
      <Page>
        <Navbar>
          {/* <NavLeft leftBreakpoint={800}>
            <Link panelOpen="left">
              <i className="icon icon-menu" />
            </Link>
          </NavLeft> */}
          <NavTitle>MERCADO ALERTA</NavTitle>
          <NavRight>
            <Link onClick={this.refresh}>
              <i className="icon icon-refresh-cw" />
            </Link>
            <Link onClick={this.logout}>
              <i className="icon icon-power" />
            </Link>
          </NavRight>
        </Navbar>
        <BlockTitle className="txt-center">Mensajes y Preguntas</BlockTitle>
        <Block>
          <table className="tableDashboard card card-outline">
            <thead>
              <tr>
                <th>Tienda</th>
                <th>Mensajes</th>
                <th>Preguntas</th>
              </tr>
            </thead>
            <tbody>
              {this.state.stores.map((store: any, index: number) => {
                return (
                  <tr key="0">
                    <td className="title">{store.name}</td>
                    <td>
                      <a
                        href="#"
                        onClick={() => {
                          this.readMessages(store.id, index);
                        }}
                      >
                        {store.dataQuestions.unlinked ? "OFF" : store.messages}
                      </a>
                      {/* {store.dataQuestions !== 0
                        ? store.dataQuestions.questions.filter(
                            (q: { status: string }) => q.status === "UNANSWERED"
                          ).length
                        : "OFF"} */}
                    </td>
                    <td>
                      <a
                        href="#"
                        onClick={() => {
                          this.readQuestions(store.id, index);
                        }}
                      >
                        {store.dataQuestions !== 0
                          ? store.dataQuestions.questions.filter(
                              (q: { status: string }) =>
                                q.status === "UNANSWERED"
                            ).length
                          : "OFF"}
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Block>

        <Block>
          <MenuTiendas stores={this.state.stores} />
          {this.state.inFilter ? (
            <Button
              fill
              color="yellow"
              raised
              className="buttonSave"
              onClick={() => {
                this.clearSearcher();
              }}
            >
              Limpiar Busqueda
            </Button>
          ) : (
            ""
          )}
        </Block>
        <Block>
          {this.state.ordersToRender.map((order: any) => {
            return <CardOrder key={order} orderData={order} self={this} />;
          })}
        </Block>
      </Page>
    );
  }

  // private async openChat(order: any) {
  //   console.log(order);
  //   const data = await api.get<any>(
  //     API_URL + CLOUD_FUNCTION + "getConversation&orderId=" + order.id,
  //     {}
  //   );
  //   console.log(data);
  // }
}



// WEBPACK FOOTER //
// ./src/components/pages/HomePage.tsx